import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Layers, Sun } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    title: 'Personal Reflection Journal',
    value: '$19',
    description: 'A guided journal to help you deepen emotional awareness and self-trust—one page at a time.',
    icon: BookOpen,
    color: 'bg-rose-100 text-rose-700'
  }, {
    title: 'Integration Action Deck',
    value: '$17',
    description: '30 daily micro-actions to practice integration—no journaling required. Quick, practical, and phone-friendly.',
    icon: Layers,
    color: 'bg-indigo-100 text-indigo-700'
  }, {
    title: 'Daily Affirmations & Empowerment Deck',
    value: '$27',
    description: 'A 30-day set of affirmations and actions to reinforce self-worth and empowerment—grounded, real, and deep.',
    icon: Sun,
    color: 'bg-amber-100 text-amber-700'
  }];
  return <section className="py-24 bg-white" data-id="element-1">
      <div className="container mx-auto px-4 md:px-6" data-id="element-2">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3">
          <FadeIn data-id="element-4">
            <span className="inline-block px-4 py-1 rounded-full bg-[#D4A574]/10 text-[#D4A574] font-semibold text-sm mb-4" data-id="element-5">
              LIMITED TIME OFFER
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-[#2D1B4E] mb-6" data-id="element-6">
              Get the eBook + 3 Bonuses (Free)
            </h2>
            <p className="text-lg text-gray-600" data-id="element-7">
              When you get{' '}
              <span className="italic font-serif" data-id="element-8">
                From Trauma to Self-Love
              </span>
              , you’ll also receive 3 practical tools—at no extra cost.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-9">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.15} className="h-full" data-id="element-10">
              <div className="relative h-full p-8 rounded-2xl border border-gray-100 shadow-lg bg-white overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-11">
                <div className={`absolute top-0 right-0 px-4 py-2 rounded-bl-2xl font-bold text-sm ${bonus.color}`} data-id="element-12">
                  Value: {bonus.value}
                </div>

                <div className={`w-14 h-14 rounded-xl ${bonus.color} flex items-center justify-center mb-6`} data-id="element-13">
                  <bonus.icon className="w-7 h-7" data-id="element-14" />
                </div>

                <h3 className="text-xl font-bold text-[#2D1B4E] mb-2" data-id="element-15">
                  Bonus {index + 1}:
                </h3>
                <h4 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-16">
                  {bonus.title}
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-17">
                  {bonus.description}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-18">
          <div className="text-center p-6 bg-[#FAF7F2] rounded-xl border border-[#D4A574]/30 max-w-2xl mx-auto" data-id="element-19">
            <p className="text-xl font-bold text-[#2D1B4E]" data-id="element-20">
              Total Bonus Value:{' '}
              <span className="text-[#D4A574] line-through" data-id="element-21">$63</span>{' '}
              <span className="text-green-600" data-id="element-22">(Included Free Today)</span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}